module.exports = __webpack_public_path__ + "img/rizz.2ffa981c.png";